var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { observer } from 'mobx-react';
import { runtime } from '../../classes/runtime/Runtime';
let AppStageRun = class AppStageRun extends React.PureComponent {
    render() {
        const { app } = this.props;
        if (app.stage.stageTypeInfo.isAbfragerStage) {
            if (!runtime.streamedPackages.Abfrager)
                return null;
            const AbfragerStage_ = runtime.streamedPackages.Abfrager.components.AbfragerStage_;
            return React.createElement(AbfragerStage_, { app: app });
        }
        if (!runtime.streamedPackages.Draft)
            return null;
        const DraftStage_ = runtime.streamedPackages.Draft.components.DraftStage_;
        return React.createElement(DraftStage_, { app: app });
    }
};
AppStageRun = __decorate([
    observer
], AppStageRun);
export { AppStageRun };
